// The type classifier for the explorer's type chips: the engine's language
// list once it has loaded, the TypeScript fallback's (the same languages)
// until then or if the engine cannot load.
import { engine } from '../engine/client';
import { fallbackEngine } from '../diff/fallback';
import { TypeClassifier } from '../logic/filefilter';

class FileTypes {
  private value: TypeClassifier = $state.raw(new TypeClassifier(fallbackEngine.languages()));
  private requested = false;

  get classifier(): TypeClassifier {
    if (!this.requested) {
      this.requested = true;
      engine.languages().then(
        (langs) => (this.value = new TypeClassifier(langs)),
        () => {},
      );
    }
    return this.value;
  }
}

export const fileTypes = new FileTypes();
